<template>
  <div>
    <Schedule />
    <!-- <Chat /> -->
  </div>
</template>

<script>
export default {
  components: {
    Schedule: () => import("./subcomponents/Schedule"),
    // Chat: () => import("./subcomponents/Chat"),
  }
}
</script>

<style>

</style>